import React from 'react'
import {
	Box,
	Flex,
	Heading,
	HStack,
	Icon,
	Link as ChakraLink,
	useColorModeValue,
} from '@chakra-ui/react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { FaDice } from 'react-icons/fa'

const navLinks = [
	{ to: '/', label: 'Home' },
	{ to: '/game-picker', label: 'Picker' },
	{ to: '/ranking-engine', label: 'Ranking' },
]

function NavItem({ to, label, active }) {
	const fg = useColorModeValue(
		active ? 'brand.600' : 'gray.600',
		active ? 'orange.100' : 'gray.200'
	)
	const bg = useColorModeValue(
		active ? 'brand.50' : 'transparent',
		active ? 'whiteAlpha.200' : 'transparent'
	)
	const hoverBg = useColorModeValue('blackAlpha.50', 'whiteAlpha.200')

	return (
		<ChakraLink
			as={RouterLink}
			to={to}
			aria-current={active ? 'page' : undefined}
			px={3}
			py={1.5}
			rounded="md"
			fontSize="sm"
			fontWeight="500"
			color={fg}
			bg={bg}
			_hover={{
				textDecoration: 'none',
				bg: active ? bg : hoverBg,
			}}
		>
			{label}
		</ChakraLink>
	)
}

export default function AppHeader() {
	const { pathname } = useLocation()
	const headerBorder = useColorModeValue('blackAlpha.50', 'whiteAlpha.300')
	const headerBg = useColorModeValue('rgba(255,255,255,0.92)', 'rgba(18, 16, 28, 0.92)')
	const logoIconColor = useColorModeValue('brand.500', 'orange.200')
	const logoTextColor = useColorModeValue('brand.600', 'orange.50')

	return (
		<Box
			as="header"
			borderBottomWidth="1px"
			borderColor={headerBorder}
			bg={headerBg}
			backdropFilter="blur(10px)"
			position="sticky"
			top={0}
			zIndex={10}
		>
			<Flex
				maxW="1100px"
				mx="auto"
				px={{ base: 4, md: 6 }}
				py={3}
				align="center"
				justify="space-between"
				gap={3}
				flexWrap="wrap"
			>
				<ChakraLink
					as={RouterLink}
					to="/"
					aria-label="BGG Picker home"
					_hover={{ textDecoration: 'none', opacity: 0.85 }}
					flexShrink={0}
				>
					<HStack spacing={2} align="center">
						<Icon as={FaDice} color={logoIconColor} boxSize="22px" aria-hidden />
						<Heading size="md" color={logoTextColor} letterSpacing="-0.03em">
							BGG Picker
						</Heading>
					</HStack>
				</ChakraLink>

				<Flex
					align="center"
					justify="flex-end"
					flexWrap="wrap"
					gap={1}
					rowGap={2}
					flex="1"
					minW={0}
				>
					<HStack spacing={1} flexWrap="wrap" justify="flex-end">
						{navLinks.map(({ to, label }) => (
							<NavItem key={to} to={to} label={label} active={pathname === to} />
						))}
					</HStack>
				</Flex>
			</Flex>
		</Box>
	)
}
